export const REGISTER_AMPLITUDE_PAGE_NAME = 'Register';
export const REGISTER_PAGE_KEY = 'register';
